import { render, staticRenderFns } from "./LegalDisclaimers.vue?vue&type=template&id=75052ecb&scoped=true&"
import script from "./LegalDisclaimers.vue?vue&type=script&lang=js&"
export * from "./LegalDisclaimers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75052ecb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75052ecb')) {
      api.createRecord('75052ecb', component.options)
    } else {
      api.reload('75052ecb', component.options)
    }
    module.hot.accept("./LegalDisclaimers.vue?vue&type=template&id=75052ecb&scoped=true&", function () {
      api.rerender('75052ecb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/system/LegalDisclaimers.vue"
export default component.exports